
import Vue from 'vue'

export default Vue.extend({
  computed: {
    hasHalfStar() {
      // to normalize the rating we  round it up to half
      // Examples
      // 4.9 -> 5
      // 4.3 -> 4.5
      // 4.1 -> 4 etc.
      const normalizedRating = Math.round(this.rating * 2) / 2
      return Math.floor(normalizedRating) !== normalizedRating
    },
    fullStars() {
      if (this.hasHalfStar) {
        return parseInt(this.rating)
      } else {
        return Math.round(this.rating)
      }
    },
    emptyStars() {
      if (this.hasHalfStar) {
        return 5 - this.fullStars - 1
      } else {
        return 5 - this.fullStars
      }
    }
  }
})
